import {connect} from 'react-redux';

import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {undoAccountDetailsBannerAction} from '../../../../store/panels/app/banners/accountDetailsUndoBannersActions';
import {AccountDetailsUndoBannerState} from '../../../../store/panels/app/banners/bannersState';
import {AccountDetailsUndoBanner} from './accountDetailsUndoBanner';

/*
 * Props.
 */

interface AccountDetailsUndoBannerContainerProps {
  panelId: AppPanelId;
  state: AccountDetailsUndoBannerState;
}

/*
 * Redux.
 */

export const AccountDetailsUndoBannerContainer = connect(
  null,
  {undoAccountDetailsBannerAction},
  (_stateProps, dispatchProps, ownProps: AccountDetailsUndoBannerContainerProps) => ({
    ...ownProps,
    onUndoClick: () => {
      const {panelId, state} = ownProps;
      dispatchProps.undoAccountDetailsBannerAction(panelId, state);
    },
  }),
)(AccountDetailsUndoBanner);
